import { onBeforeUnmount } from "vue";
import { API_BASE_URL } from "../../../consts";
import { safeParse } from "../shared/safeParse";

const POLL_MAX_MS = 5 * 60 * 1000;

export function useVideoGenerationPolling(token, onSettled) {
  let activeEventSource = null;
  let activeTimeoutId = null;
  let watchedIds = [];

  const closeStatusStream = () => {
    activeEventSource?.close();
    activeEventSource = null;
    clearTimeout(activeTimeoutId);
    activeTimeoutId = null;
    watchedIds = [];
  };

  const openStatusStream = (ids) => {
    closeStatusStream();
    if (!ids.length) return;
    watchedIds = ids;

    const url = `${API_BASE_URL}/snippets/video-generation-status-stream?snippetIds=${ids.join(
      ","
    )}&token=${encodeURIComponent(token)}`;
    const es = new EventSource(url);

    es.onmessage = (event) => {
      const data = safeParse(event.data);
      if (data && Object.values(data).some((generating) => !generating)) {
        onSettled();
      }
    };

    es.onerror = closeStatusStream;

    activeTimeoutId = setTimeout(() => {
      closeStatusStream();
      onSettled();
    }, POLL_MAX_MS);

    activeEventSource = es;
  };

  const syncStatusStream = (ids) => {
    const sorted = [...ids].sort();
    const unchanged =
      sorted.length === watchedIds.length &&
      sorted.every((id, i) => id === watchedIds[i]);
    if (!unchanged) openStatusStream(sorted);
  };

  onBeforeUnmount(closeStatusStream);

  return { syncStatusStream };
}
